import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import API from "../api/axios";
import toast from "react-hot-toast";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    try {
      await API.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password reset successfully");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={styles.wrapper}>
        <div style={styles.card}>
          <p style={{ color: "#e74c3c", textAlign: "center" }}>
            Invalid reset link. Please request a new one.
          </p>
          <Link to="/forgot-password" style={styles.backBtn}>
            Request New Link
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
       <div style={{ display: "flex", alignItems: "center", gap: "0px", marginBottom: "24px" }}>
  <img
    src="/logo.png"
    alt="MartSense"
    style={{ width: "80px", height: "80px", objectFit: "contain", flexShrink: 0, marginRight: "-14px" }}
  />
  <span style={{ fontSize: "28px", fontWeight: "800", letterSpacing: "-0.5px" }}>
    <span style={{ color: "#21bdae" }}>Mart</span>
    <span style={{ color: "#f6a809" }}>Sense</span>
  </span>
</div>
        <h1 style={styles.title}>Set New Password</h1>
        <p style={styles.sub}>Enter your new password below.</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>New Password</label>
            <div style={styles.inputWrap}>
              <input
                type={show ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                style={styles.input}
              />
              <button
                type="button"
                onClick={() => setShow(!show)}
                style={styles.eyeBtn}
              >
                {show ? "🙈" : "👁"}
              </button>
            </div>
          </div>
          <button type="submit" disabled={loading} style={styles.btn}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: "100vh", display: "flex", alignItems: "center",
    justifyContent: "center", background: "#0a0f0f", padding: "20px",
  },
  card: {
    background: "#0f1a1a", border: "1px solid #1e3333", borderRadius: "16px",
    padding: "40px 32px", width: "100%", maxWidth: "460px",
    boxShadow: "0 24px 64px rgba(0,0,0,0.4)",
  },
  logo: { display: "flex", alignItems: "center", gap: "10px", marginBottom: "32px" },
  logoIcon: { fontSize: "32px" },
  logoText: { fontSize: "26px", fontWeight: "700", color: "#2ec4b6", letterSpacing: "-0.5px" },
  title: { fontSize: "26px", fontWeight: "700", color: "#e8f5f5", marginBottom: "8px" },
  sub: { fontSize: "15px", color: "#5a8a8a", marginBottom: "32px" },
  form: { display: "flex", flexDirection: "column", gap: "20px" },
  field: { display: "flex", flexDirection: "column", gap: "8px" },
  label: { fontSize: "14px", fontWeight: "500", color: "#5a8a8a" },
  inputWrap: { position: "relative" },
  input: {
    background: "#162424", border: "1px solid #1e3333", borderRadius: "10px",
    padding: "14px 48px 14px 16px", color: "#e8f5f5", fontSize: "16px",
    outline: "none", width: "100%",
  },
  eyeBtn: {
    position: "absolute", right: "14px", top: "50%",
    transform: "translateY(-50%)", background: "none",
    border: "none", fontSize: "18px", cursor: "pointer",
  },
  btn: {
    background: "linear-gradient(135deg, #2ec4b6, #1a9e92)",
    color: "#0a0f0f", border: "none", borderRadius: "10px",
    padding: "16px", fontSize: "16px", fontWeight: "700", width: "100%",
  },
  backBtn: {
    display: "block", textAlign: "center", marginTop: "24px",
    background: "linear-gradient(135deg, #2ec4b6, #1a9e92)",
    color: "#0a0f0f", borderRadius: "10px", padding: "14px",
    textDecoration: "none", fontWeight: "700",
  },
};